// hooks/useSEO.js
import { useEffect, useRef } from "react";
import { seoManager } from "../utils/seoManager";
import { IS_DEVELOPMENT } from "../utils/constant";

export const useSEO = (route, params = {}) => {
  const previousKey = useRef();

  useEffect(() => {
    // Don't apply SEO if params is null (data not loaded yet)
    if (params === null) return;
    
    // Create a unique key from route and params
    const currentKey = `${route}_${JSON.stringify(params)}`;
    
    if (previousKey.current === currentKey) return;
    previousKey.current = currentKey;

    const seoData = seoManager.generateSEO(route, params);
    
    if (seoData?.metaTags) {
      if (IS_DEVELOPMENT) {
        console.log("SEO Updated for:", route, params);
      }
      
      // Update title
      document.title = seoData.metaTags.title;
      
      // Remove existing SEO meta tags
      const tagsToRemove = [
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[name="author"]',
        'meta[name="robots"]',
        'meta[property^="og:"]',
        'meta[name^="twitter:"]',
        'link[rel="canonical"]'
      ];
      
      tagsToRemove.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => el.remove());
      });
      
      // Add new meta tags
      seoData.metaTags.meta?.forEach((tag) => {
        const meta = document.createElement('meta');
        if (tag.name) meta.setAttribute('name', tag.name);
        if (tag.property) meta.setAttribute('property', tag.property);
        meta.setAttribute('content', tag.content);
        document.head.appendChild(meta);
      });
      
      // Add canonical link
      seoData.metaTags.link?.forEach((link) => {
        const linkTag = document.createElement('link');
        linkTag.setAttribute('rel', link.rel);
        linkTag.setAttribute('href', link.href);
        document.head.appendChild(linkTag);
      });
    }
  }, [route, params ? JSON.stringify(params) : null]);
};